import { useEffect, useState } from 'react';
import styles from '../customerservice.module.css'

function ChatCard({ chat, setSelectedChat }) {
    return (
        <div className={styles.chatCard} onClick={() => {
            setSelectedChat(chat.id)
        }}>
            <div className={styles.chatCardHeader}>
                <h4>{chat.customer_name}</h4>
                <p>{chat.msgs[chat.msgs.length - 1].msg}</p>
            </div>
            <div className={styles.chatCardFooter}>
                <p>{chat.msgs[chat.msgs.length - 1].time}</p>
            </div>
        </div>
    )
}
function Message({ msg, isCustomer }) {
    return (
        <div className={styles.message + " " + (isCustomer ? styles.user : styles.agent)}>
            <p className={styles.msg}>{msg}</p>
            <p className={styles.timestamp}>10:00 AM</p>
        </div>
    )
}


function ChatWindow({ chat, handleMessage }) {
    useEffect(() => {
        console.log("he")
        console.log(chat)
    }, [])

    return (
        <section className={styles.chatWindow}>
            <div className={styles.chatWindowHeader}>
                <h3>{chat.customer_name}</h3>
                <div className={styles.dropdownIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                    </svg>
                </div>
            </div>
            <div className={styles.chatWindowBody}>
                {
                    chat.msgs.map((e, idx) => {
                        return <Message key={idx} msg={e.msg} isCustomer={e.isCustomer} />
                    })
                }

            </div>

            <form className={styles.chatWindowFooter} onSubmit={handleMessage}>
                <textarea
                    rows={3}
                    placeholder='Type Your Message...'
                    name='message'
                ></textarea>
                <button type='submit' className={styles.sendButton}>
                    <span class="text">Send</span>
                </button>
            </form>

        </section>
    )
}
export default function CustomerService() {
    const array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12]
    const [chat, setChat] = useState([
        {
            id: 1,
            customer_name: "John Doe",
            msgs: [
                {
                    msg: 'Hello How may I help you?',
                    isCustomer: false,
                    time: '10:00 AM'
                },
                {
                    msg: 'I wanted to ask about the MRI installation',
                    isCustomer: true,
                    time: '10:30 AM'
                }
            ]
        },
        {
            id: 2,
            customer_name: "Aman Tesfaye",
            msgs: [
                {
                    msg: 'Hello How may I help you?',
                    isCustomer: false,
                    time: '10:00 AM'
                },
                {
                    msg: 'I wanted to ask about the CT installation',
                    isCustomer: true,
                    time: '10:15 AM'
                }
            ]
        }
    ])
    const [selectedChat, setSelectedChat] = useState(null)

    function handleMessage(e) {
        e.preventDefault();
        console.log(e.target.message.value)
        const message = e.target.message.value;
        e.target.reset();
        console.log(chat);
        console.log(Array.isArray(chat));
        console.log(selectedChat)

        setChat(prev => {
            return prev.map(conversation =>
                conversation.id === parseInt(selectedChat)
                    ?
                    {
                        ...conversation,
                        msgs: [
                            ...conversation.msgs,
                            {
                                msg: message,
                                isCustomer: false
                            }
                        ]
                    }
                    :
                    conversation
            )
        })
    }

    return (
        <div className={styles.customerServiceContainer}>
            <section className={styles.chatList}>
                {
                    chat.map(element => {
                        return <ChatCard chat={element} setSelectedChat={setSelectedChat} />

                    })
                }

            </section>
            {
                selectedChat && <ChatWindow handleMessage={handleMessage} chat={chat.find(
                    conversation => conversation.id === parseInt(selectedChat)
                )} />
            }
        </div>

    );
}